import { Reducer } from 'redux';

import { IAuthState } from 'types/auth.types';
import * as constants from 'redux/constants/auth.constants';

export const defaultState: IAuthState = {
  data: null,
  loading: false,
};

const userReducer: Reducer = (state = defaultState, action) => {
  const { data, error, type } = action;
  switch (type) {
    case constants.AUTH_ON_LOGIN_REQUESTED:
    case constants.AUTH_ON_LOGIN_PUBLIC_REQUESTED:
    case constants.AUTH_ON_REGISTER_PUBLIC_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.AUTH_ON_INITIALIZE_SUCCEEDED:
    case constants.AUTH_ON_LOGIN_SUCCEEDED:
    case constants.AUTH_ON_LOGIN_PUBLIC_SUCCEEDED:
      return {
        ...state,
        data: data.user,
        loading: false,
      };
    case constants.AUTH_ON_LOGOUT_SUCCEEDED:
    case constants.AUTH_ON_LOGOUT_PUBLIC_SUCCEEDED:
    case constants.AUTH_ON_REGISTER_PUBLIC_SUCCEEDED:
    case constants.AUTH_ON_INITIALIZE_FAILED:
    case constants.AUTH_ON_LOGIN_FAILED:
    case constants.AUTH_ON_LOGIN_PUBLIC_FAILED:
    case constants.AUTH_ON_REGISTER_PUBLIC_FAILED:
      return defaultState;
    case constants.AUTH_ON_LOGOUT_FAILED:
    case constants.AUTH_ON_LOGOUT_PUBLIC_FAILED:
    default:
      return error?.response?.status === 401 ? defaultState : state;
  }
};

export default userReducer;
